module.exports = __webpack_public_path__ + "img/OneTradingMarkets-logo.ce763057.png";